module.exports = __webpack_public_path__ + "img/Widget_card_headpics_EB_service.991eb784.jpg";